import productsReducer from './products.reducer';
export default productsReducer;

export * from './products.selectors';
